import { render, staticRenderFns } from "./AttachmentPreviewModal.vue?vue&type=template&id=9c847804&scoped=true&"
import script from "./AttachmentPreviewModal.vue?vue&type=script&lang=js&"
export * from "./AttachmentPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentPreviewModal.vue?vue&type=style&index=0&id=9c847804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c847804",
  null
  
)

export default component.exports